import React from "react";
import { useTranslation } from "react-i18next";

export default function ActivityOptions(props) {
  const { t } = useTranslation();
  return (
    <li className="draw-toolbar-icon">
      <span
        className={`button normal-btn main-button is-hidden-mobile ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "teacher-tools" ? "active" : ""
        }${props.hideButton ? "passive" : ""}  ${props.isAlternative ? "main-button-alternative" : ""}`}
        title={t("Teacher Tools")}
        data-tip={t("Teacher Tools")}
        onClick={props.onClick}
      >
        <img
          src={require("../../assets/img/svg/toolbar-lecture.svg")}
          alt={t("Teacher Tools")}
        />
         {props.shouldShowButtonLabels && <span className="show-label-text">{t("Tools")}</span>}
      </span>
    </li>
  );
}
